import React,{useState} from 'react';
import { Box, TextField, Button, Typography, Grid2, InputAdornment , IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Link, useNavigate,useLocation } from 'react-router-dom';
import LogoIcon from '../../assets/images/LogoIcon.svg';
import LogoText from '../../assets/images/LogoText.svg';
import Aadhar from '../../assets/images/aadhar card.svg';
import Password from '../../assets/images//password.png';
import HidePassword from '../../assets/images/hidePassword.png';
import mail from '../../assets/images/email.svg';
import mobile from '../../assets/images/mobile-alt.svg';
import passwordimg from '../../assets/images/passwordimg.svg';
import rightArrow from '../../assets/images/right.svg'
import fullName from '../../assets/images/full-name.svg'
import * as Yup from "yup";
import { useFormik } from "formik";
import Snackbars from "../../utils/Snackbars";
import useRequestsWOAccessToken from '../../utils/useRequestsWOAccessToken';

const AddPhoneAadhar = () => {
    const navigate = useNavigate();
    const location = useLocation()
    const { postRequestWOAccessToken } = useRequestsWOAccessToken();
    // const [formData, setFormData] = useState({
    //     fullName:" ",
    //     email:"",
    // });
     const [AlertData, setAlertData] = React.useState({
            variant: '',
            message: '',
        });
        const resetAlertData = () => {
            setTimeout(() => {
                setAlertData((AlertData) => ({
                    ...AlertData,
                    variant: '',
                    message: '',
                }));
            }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
        };
        const [showPassword, setShowPassword] = useState(false);
        const [confirmShowPassword, setConfirmShowPassword] = useState(false);

        const validation1 = useFormik({
                enableReinitialize: true,
            
                initialValues: {
                  phone: '',
                  // aadhar:''
                },
                validationSchema: Yup.object({
                  phone: Yup.string()
                    .matches(/^[0-9]{10}$/, 'Please enter a valid 10-digit phone number!')
                    .required('Phone number is required'),
                  // aadhar:Yup.string()
                  // .required('Aadhar number is  required')
                  // .matches(/^\d{12}$/, 'Aadhar Card must be exactly 12 digits'),
                }),
               onSubmit: async ( values) => {
                // e.preventDefault();
                try{


                  let submit1 = document.getElementById('submit1');
                  submit1.disabled = true;
                  submit1.textContent = ('Processing...');

                const jsonpar = JSON.stringify({
                  email: location.state?.email,
                  phone: values.phone,
                  // aadhar:values.aadhar,
                });
                const res = await postRequestWOAccessToken('auth/addphoneaadhar', jsonpar);
                if (res && res.code === 200) {
                    const params = location.search ? location.search : "";
                    navigate(`/verify-phone${params}`, {
                        state: {
                            email: location.state?.email,
                            phone: values.phone,
                            tokenDetails: location.state.tokenDetails,
                        }
                    })
                  
                }
                else {
                  setAlertData((AlertData) => ({
                    ...AlertData,
                    variant: 'error',
                    message: res.message,
                  }));
                }
                resetAlertData();
                submit1.disabled = false;
                submit1.textContent = ('Update');
              }catch (error) {
                console.error("Error : ", error);
                setAlertData((AlertData) => ({
                  ...AlertData,
                  variant: 'error',
                  message: 'An error occurred while register the user.',
                }));
              resetAlertData();
              }
            }
              });
        
              React.useEffect(() => {
                if (location.state && typeof location.state.message !== 'undefined') {
                  setAlertData((AlertData) => ({
                    ...AlertData,
                    variant: location.state.status,
                    message: location.state.message,
                  }));
                  resetAlertData();
                }
              }, []);
            


    return (
        <Grid2>
            {/* <Link className='skip' to="/">Skip <img src={rightArrow} alt='' /></Link> */}
            {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 'calc(98vh - 33px)' }}>
                <Box sx={{ width: 500, padding: 4, borderRadius: 2, backgroundColor: '#fff', textAlign: 'center', }}>
                    <Grid2 className="fullLogo">
                        <div className='centerLogo'>
                            <img src={LogoIcon} alt="Logo" width={80} style={{ marginBottom: "10px" }} />
                        </div>
                        <div className='centerLogo'>
                            <img src={LogoText} alt="Logo" width={180} />
                        </div>
                    </Grid2>
                    <Typography variant="h4" component="h1" gutterBottom className='signin-title'>Update Phone</Typography>
                    <form className='loginForm'>

                        <div className='position-relative'>
                            <img src={mobile} alt="Logo" width={24} className='textboxLefticon' />
                            <TextField variant="outlined" fullWidth margin='normal' placeholder='Phone' autoComplete='off' 
                            name='phone'
                            type="number"
                            className={`form-control ${validation1.touched.phone && validation1.errors.phone ? 'is-invalid' : ''}`}
                            value={validation1.values.phone || ""}
                            // onChange={(e) => setEmail(e.target.value)}
                            onChange={validation1.handleChange}
                            invalid={
                              validation1.touched.phone && validation1.errors.phone ? true : false
                            }
                           />
                           {validation1.touched.phone && validation1.errors.phone ? (
                           <div className="invalid-feedback" >{validation1.errors.phone}</div>
                         ) : null}
                        </div>

                        {/* <div className='position-relative'>
                            <img src={Aadhar} alt="Logo" width={24} className='textboxLefticon' />
                            <TextField  type="text" inputMode="numeric" pattern="[0-9]*" variant="outlined" fullWidth margin='normal' placeholder='Aadhar Card' required 
                            name='aadhar'
                            className={`password-textbox form-control ${validation1.touched.aadhar && validation1.errors.aadhar ? 'is-invalid' : ''}`}
                            onChange={validation1.handleChange}
                            value={validation1.values.aadhar || ""}
                            invalid={
                              validation1.touched.aadhar && validation1.errors.aadhar ? true : false
                            }
                            // style={{borderColor:'red'}}
                          />
                          {validation1.touched.aadhar && validation1.errors.aadhar ? (
                            <div type="invalid" className="invalid-feedback" >{validation1.errors.aadhar}</div>
                          ) : null}
                        </div> */}


                        <Button  variant="contained" color="primary" fullWidth sx={{ marginTop: 2 }} 
                            type="submit" 
                            id='submit1' 
                            className="btn-common btn bg-primary text-white btn-block"
                            onClick={(e) => {
                              e.preventDefault();
                              validation1.handleSubmit();
                              return false;
                            }}>
                            {('Update')}
                        </Button>
                    </form>
                </Box>
            </Box>
            {/* <Typography className='dont'>
                Already have an account? <Link to="/">Sign in Now</Link>
            </Typography> */}
        </Grid2>
    );
};
export default AddPhoneAadhar;